import { render, staticRenderFns } from "./VrRefundView.vue?vue&type=template&id=388a558e&scoped=true"
import script from "./VrRefundView.vue?vue&type=script&lang=js"
export * from "./VrRefundView.vue?vue&type=script&lang=js"
import style0 from "./VrRefundView.vue?vue&type=style&index=0&id=388a558e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388a558e",
  null
  
)

export default component.exports